// apis/barchartdata.js
import { APIBase } from "./apibase";
const Camur = require("@/utils/camurutils").default;

export class BarChartData extends APIBase {
  fetch(
    start,
    stop,
    max_vals,
    project_id,
    zone_id,
    channel_ids,
    filters = {},
    cache_data = false,
    all_values = false,
    value_tag = 0
  ) {

    let urlpath = `projects/${project_id}/data`;
    if (all_values) urlpath += "/all";
    // console.log("start date", start)
    const sISO = start.toISOString();
    const eISO = stop.toISOString();

    let command =
      `${urlpath}?Start=${encodeURIComponent(sISO)}` +
      `&Stop=${encodeURIComponent(eISO)}` +
      `&MaxValues=${max_vals}` +
      `&ChannelIds=${channel_ids.join()}`;

    if (filters.recordingId > 0) {
      command += `&RecordingIds=${filters.recordingId}`;
    }

    if (filters.recordingType > 0) {
      command += `&RecordingTypes=${filters.recordingType}`;
    } else {
      const types = [
        Camur.recording_type.rectype_monitor,
        Camur.recording_type.rectype_lpr,
        Camur.recording_type.rectype_decay,
        Camur.recording_type.rectype_zra,
        Camur.recording_type.rectype_resmes,
      ];
      command += `&RecordingTypes=${types.join(",")}`;
    }

    command += `&ValueTag=${value_tag}`;

    return new Promise((resolve, reject) => {
      this.send({
        command,
        method: "GET",
        parse_response_as_json: true,
        on_receive: (response) => resolve(response),
        identification: {
          project_id,
          cache_data,
          from: start,
          to: stop,
          filters,
          zone_ids: [zone_id],
          max_values: max_vals,
        },
        custom_callback: null,
        refresh_interval: 0,
        on_error: reject,
      });
    });
  }
}
